module.exports = __webpack_public_path__ + "static/media/lions-panel.d1d7cc33.png";